<template>
  <div v-if="menuPersonalYn == true">
    <div class="dimed wrap">
      <div class="layer new" :class="{admin: adminModeYn}">
        <div class="menu__header">
          <div class="menu-title">{{ itemObj.DIS_ITEM_NM }}</div>
          <div class="menu-image">
            <div class="toggle-wrap" v-if="adminModeYn" @mouseup="modalSoldout()">
              <input type="checkbox" id="toggle02" hidden :checked="itemObj.SLDOUT_YN == 'N'" />
              <label for="toggle02" class="toggle-switch">
                <span class="on">{{ $t('User.Order.msg18') }}</span>
                <span class="off">{{ $t('User.Order.msg8') }}</span>
                <span class="toggle-btn"></span>
              </label>
            </div>
            <img :src="itemObj.SUB_ITEM_IMG_FILE_URL" @error="replaceToDefaultImg" />
          </div>
          <div class="menu-info">
            <span class="menu-price">{{ $displayUprc($detailUprc(itemObj)) }}</span>
            <!-- 상품 정보 넣기 -->
            <p class="menu-txt">{{ itemObj.ITEM_DESC }}</p>
            <button
              v-if="this.orderType != 'F'"
              class="btn-open-txt btn-anim"
              :class="{'btn-rev': optionInfoYn}"
              @click="
                if (optionInfoYn) optionInfoYn = false;
                else optionInfoYn = true;
              "
            >
              {{ $t('Modal.MenuPersonal.msg1') }}
            </button>
          </div>
        </div>
        <!-- //header -->

        <!-- body -->
        <div class="menu__body" v-show="optionInfoYn == false">
          <div class="menu__select-option">
            <!-- row -->
            <div class="row">
              <div class="ms-head">
                <span class="m-txt">{{ $t('Modal.MenuPersonal.msg2') }}</span>
              </div>
              <div class="ms-data">
                <button
                  class="btn-minus btn-anim"
                  :style="[SALES_QTY > 1 ? '' : {'box-shadow': 'none'}]"
                  :class="{on: SALES_QTY > 1}"
                  @click="if (SALES_QTY > 1) SALES_QTY--;"
                >
                  빼기
                </button>
                <span class="txt-btwbtn">{{ SALES_QTY }}</span>
                <button class="btn-plus on btn-anim" @click="if (SALES_QTY > 0 && SALES_QTY < 100) SALES_QTY++;">더하기</button>
              </div>
            </div>
            <!-- //row -->

            <div name="option" class="row" v-if="this.orderType != 'F'" v-for="(option, i) in optionList" :key="i">
              <div class="ms-head">
                <span class="m-txt">{{ option.OPT_CLAS_NM }}</span>
                <span class="s-txt" :class="{on: option.OPT_URPC > 0}">+ {{ $displayUprc(option.OPT_URPC) }}</span>
              </div>
              <div class="ms-data">
                <div class="lst-option-wrap" :style="{'padding-right': option.optionItemList.length > 3 ? '3em' : '0'}">
                  <ul class="lst-option">
                    <li v-for="item in option.optionItemList" :key="item">
                      <input
                        :checked="option.SELECT_CD == item.OPT_ITEM_CD"
                        :disabled="option.OPT_MULTI_USE_YN == 'N'"
                        type="checkbox"
                        :name="option.OPT_CLAS_CD"
                        :id="item.OPT_ITEM_CD"
                        class="radio-t01"
                      />
                      <label @click="optionCheck(option, item.OPT_ITEM_CD)" :for="item.OPT_ITEM_CD">{{ item.PRESET_NM }}</label>
                    </li>
                  </ul>
                  <button class="btn-arr-l btn--sm btn-anim" v-if="option.optionItemList.length > 3" @mouseup="optionLeft">좌</button>
                  <button class="btn-arr-r btn--sm btn-anim" v-if="option.optionItemList.length > 3" @mouseup="optionRight">우</button>
                </div>
              </div>
            </div>
            <div class="wind-detail-wrap" v-else>
              <img :src="itemObj.ITEM_DESC_TW" />
            </div>
          </div>
        </div>

        <SideMenu @sideBasket="sideBasket" v-if="sideMenuYn && orderType != 'F'" v-show="optionInfoYn != true" :itemObj="itemObj" :optionCnt="optionCnt" />
        <OptionInfo :itemObj="itemObj" v-show="optionInfoYn == true" />
        <!-- //body -->

        <!-- footer -->
        <div class="footer-wrap" :class="{'f-type': orderType == 'F'}">
          <div class="menu__footer">
            <dl class="option-price" v-if="this.orderType != 'F'">
              <dt>{{ $t('Modal.MenuPersonal.msg5') }}</dt>
              <dd>{{ $displayUprc(SALES_QTY * totOptUprc) }}</dd>
            </dl>
            <dl class="basic-price">
              <dt>{{ $t('Modal.MenuPersonal.msg6') }}</dt>
              <dd>{{ $displayUprc(SALES_QTY * ($detailUprc(itemObj) + totOptUprc)) }}</dd>
            </dl>
          </div>
          <!-- //footer -->

          <div class="layer__button">
            <button class="btn btn--cancel btn-anim" @mouseup="close()">{{ $t('Modal.MenuPersonal.msg8') }}</button>
            <button class="btn btn--submit btn-anim" :class="{'btn--admin': adminModeYn}" :disabled="itemObj.SLDOUT_YN == 'Y'" @mouseup="onEmit()">
              {{ $t('Modal.MenuPersonal.msg7') }}
            </button>
          </div>
        </div>
      </div>
      <!-- //modal -->
    </div>
  </div>
</template>

<script>
import optionInfo from '@/components/user/order/OptionInfo.vue';
import sideMenu from '@/components/user/order/SideMenu.vue';
import _ from 'lodash';
import audioHelper from '@/js/common/audioHelper.js';

export default {
  name: 'menuPersonal',
  data() {
    return {
      optionInfoYn: false,
      darkModeYn: this.$store.getters.getDarkModeYn,
      adminModeYn: this.$store.getters.getAdminModeYn,
      SALES_QTY: 1,
      optionList: [],
      totOptUprc: 0,
      sideList: [],
      //사이드 상품 노출 여부
      sideMenuYn: this.$store.getters.getPosConfig.posConfig.sideProductExposure,
      orderType: this.$store.getters.getPosConfig.posConfig.templateNo,
      tbMstOpt: this.$store.getters.getTbMstOpt,
      tbMstItem: this.$store.getters.getTbMstItem,
    };
  },
  props: {
    menuPersonalYn: Boolean,
    itemObj: Object,
  },
  created() {},
  beforeMount() {
    this.getOption();
  },
  mounted() {
    if (this.optionList.length > 0 && this.optionList[0].optionItemList.length > 0) {
      this.optionCheck(this.optionList[0], this.optionList[0].optionItemList[0].OPT_ITEM_CD);
    }
  },
  updated() {
    this.$showButtonAnimation();
  },
  methods: {
    optionLeft(e) {
      e.target.parentElement.scrollLeft = e.target.parentElement.scrollLeft - 50;
    },
    optionRight(e) {
      e.target.parentElement.scrollLeft = e.target.parentElement.scrollLeft + 50;
    },
    replaceToDefaultImg(e) {
      // 상품 이미지 로딩 실패 시 기본 이미지 표시
      e.target.src = require('@/assets/images/common/no-image.png');
    },
    modalSoldout() {
      let checked = document.getElementById('toggle02').checked;
      this.$emit('modalSoldout', this.itemObj.DIS_ITEM_CD, checked);
    },
    sideBasket(option, num) {
      if (num == 1) {
        this.$logInfo(`SideMenu Basket Add OPT_ITEM_CD : ${option.OPT_ITEM_CD}, Qty : ${option.SALES_QTY}`);
        if (this.sideList.filter((side) => side.ITEM_CD == option.ITEM_CD).length == 0) {
          this.sideList.push(option);
        } else {
          this.sideList.filter((side) => side.ITEM_CD == option.ITEM_CD)[0].SALES_QTY++;
        }
      } else {
        if (this.sideList.filter((item) => item.ITEM_CD == option.ITEM_CD).length > 0) {
          this.$logInfo(`SideMenu Basket Remove OPT_ITEM_CD : ${option.OPT_ITEM_CD}, Qty : ${option.SALES_QTY}`);
          let side = this.sideList.filter((item) => item.OPT_ITEM_CD == option.OPT_ITEM_CD)[0];
          side.SALES_QTY--;
          if (side.SALES_QTY <= 0) {
            for (let i = 0; i < this.sideList.length; i++) {
              if (this.sideList[i] == side) {
                this.sideList.splice(i, 1);
                i--;
              }
            }
          }
        }
      }
    },
    onEmit() {
      let prd = _.cloneDeep(this.itemObj);
      let loggerItem = {
        DIS_ITEM_CD: prd.DIS_ITEM_CD,
        SALES_QTY: prd.SALES_QTY,
        SALE_UPRC: prd.SALE_UPRC,
        TOTAL_UPRC: prd.SALES_QTY * prd.SALE_UPRC,
      };

      let option = new Array();
      let option2 = new Array();
      let opt = document.querySelectorAll('input[type="checkbox"]:checked');
      const posConfig = this.$store.getters.getPosConfig.posConfig;
      opt.forEach((item) => {
        this.optionList.forEach((item2) => {
          let check = item2.optionItemList.filter((item3) => item3.OPT_ITEM_CD == item.id);

          if (check && check.length > 0) {
            let orgName;
            if (posConfig.defaultLanguage == 'KO') orgName = check[0].PRESET_NM_KO;
            else if (posConfig.defaultLanguage == 'JP') orgName = check[0].PRESET_NM_JP;
            else if (posConfig.defaultLanguage == 'EN') orgName = check[0].PRESET_NM_EN;
            else if (posConfig.defaultLanguage == 'CH') orgName = check[0].PRESET_NM_CN;
            else if (posConfig.defaultLanguage == 'TW') orgName = check[0].PRESET_NM_TW;

            let optItem = {
              ITEM_CD: check[0].OPT_ITEM_CD,
              ITEM_NM: check[0].PRESET_NM,
              ITEM_ORG_NM: orgName,
              ITEM_PARENT_NM: item2.OPT_CLAS_NM,
              CLAS_L_CD: check[0].CLAS_L_CD,
              CLAS_M_CD: check[0].CLAS_M_CD,
              CLAS_S_CD: check[0].CLAS_S_CD,
              TAX_FLG_CD: check[0].TAX_FLG_CD,
              TAX_RDC_CD: check[0].TAX_RDC_CD,
              TAX_RDC_FLG_CD: check[0].TAX_RDC_FLG_CD,
              NRML_UPRC: check[0].SALE_UPRC,
              SALES_QTY: 1,
              SALE_UPRC: check[0].SALE_UPRC,
              SALES_UPRC: check[0].SALE_UPRC,
              SUPY_UPRC: check[0].SUPY_UPRC,
              MG_RATE: check[0].MG_RATE,
              DC_ABLE_YN: check[0].DC_ABLE_YN,
              DC_AMT: 0.0,
              SALES_AMT: 0,
              VAT_AMT: 0,
              VAT_RATE: 0,
              SVC_AMT: 0,
              EVNT_CD: check[0].EVNT_CD,
              EVNT_NM: check[0].EVNT_NM,
              EVNT_KIND_CD: check[0].EVNT_KIND_CD,
              EVNT_FLG_CD: check[0].EVNT_FLG_CD,
              EVNT_DC_FLG_CD: check[0].EVNT_DC_FLG_CD,
              DC_ITEM_QTY: 1,
              EVNT_DC_AMT: check[0].EVNT_DC_AMT,
              EVNT_ITEM_CD: check[0].EVNT_ITEM_CD,
              EVNT_FROM_DATE: check[0].EVNT_FROM_DATE,
              EVNT_END_DATE: check[0].EVNT_END_DATE,
              TIME_SALE_YN: check[0].TIME_SALE_YN,
              TIME_SALE_FROM_TIME: check[0].TIME_SALE_FROM_TIME,
              TIME_SALE_END_TIME: check[0].TIME_SALE_END_TIME,
            };
            option.push(optItem);
            let optItem2 = {
              ITEM_CD: check[0].OPT_ITEM_CD,
              SALES_UPRC: check[0].SALE_UPRC,
            };
            option2.push(optItem2);
          }
        });
      });
      option.sort();
      prd.SALE_UPRC = prd.SALE_UPRC;
      prd.OPTIONITEM = option;
      prd.SALES_QTY = this.SALES_QTY;
      this.optionInfoYn = false;
      this.SALES_QTY = 1;
      this.totOptUprc = 0;
      loggerItem.OPTIONITEM = option2;

      this.$logInfo(`Basket Add Item : ${JSON.stringify(loggerItem)}`);

      if (this.sideList.length > 0) {
        this.$emit('setSideBasket', this.sideList);
        this.sideList = [];
      }
      this.$emit('setBasket', prd);
    },
    close() {
      this.$logInfo(`Item and Side Cancel DIS_ITEM_CD : ${this.itemObj.DIS_ITEM_CD}`);

      this.optionInfoYn = false;
      this.SALES_QTY = 1;
      this.totOptUprc = 0;
      this.sideList = [];
      this.optionList = new Array();
      this.$emit('closeMenuPersonal');
    },
    optionCheck(option, id) {
      if (option.OPT_MULTI_USE_YN == 'Y') {
        let uprc = option.optionItemList.filter((item) => item.OPT_ITEM_CD == id).map((item) => item.SALE_UPRC);
        let detailUprc2 = this.$detailUprc(option.optionItemList.filter((item) => item.OPT_ITEM_CD == id)[0]);
        if (!document.getElementById(id).checked) {
          option.OPT_URPC += detailUprc2;
          this.totOptUprc += detailUprc2;
        } else {
          option.OPT_URPC -= detailUprc2;
          this.totOptUprc -= detailUprc2;
        }
      } else {
        this.totOptUprc -= option.OPT_URPC;
        if (option.SELECT_CD == id) {
          if (option.OPT_CLAS_CD == 'OPT00002') {
            this.totOptUprc += option.OPT_URPC;
            return false;
          }
          option.SELECT_CD = '';
          option.OPT_URPC = 0;
        } else {
          option.SELECT_CD = id;
          let detailUprc2 = this.$detailUprc(option.optionItemList.filter((item) => item.OPT_ITEM_CD == option.SELECT_CD)[0]);
          let uprc = option.optionItemList.filter((item) => item.OPT_ITEM_CD == option.SELECT_CD).map((item) => item.SALE_UPRC);
          option.OPT_URPC = detailUprc2;
          this.totOptUprc += detailUprc2;
        }
      }
    },
    getOption() {
      console.log(this.tbMstOpt);
      console.log(this.tbMstItem);
      let data = JSON.parse(JSON.stringify(this.tbMstOpt.filter((item) => item.OPT_GRP_CD == this.itemObj.OPT_GRP_CD && item.OPT_GBN != '03')));

      data.forEach((item) => {
        let OPT_CLAS_CD = item.OPT_CLAS_CD;
        let optionItemList = this.tbMstItem.filter((item2) => item2.OPT_CLAS_CD == OPT_CLAS_CD);
        item.optionItemList = optionItemList;
      });

      this.optionList = data;
      this.optionCnt = data.length;
      if (this.$i18n.locale == 'jp') {
        this.optionList.forEach((item) => {
          item.OPT_CLAS_NM = item.OPT_CLAS_JP_NM;
          item.optionItemList.forEach((item2) => {
            item2.PRESET_NM = item2.PRESET_NM_JP;
          });
        });
      } else if (this.$i18n.locale == 'ko') {
        this.optionList.forEach((item) => {
          item.OPT_CLAS_NM = item.OPT_CLAS_KO_NM;
          item.optionItemList.forEach((item2) => {
            item2.PRESET_NM = item2.PRESET_NM_KO;
          });
        });
      } else if (this.$i18n.locale == 'en') {
        this.optionList.forEach((item) => {
          item.OPT_CLAS_NM = item.OPT_CLAS_EN_NM;
          item.optionItemList.forEach((item2) => {
            item2.PRESET_NM = item2.PRESET_NM_EN;
          });
        });
      } else if (this.$i18n.locale == 'cn') {
        this.optionList.forEach((item) => {
          item.OPT_CLAS_NM = item.OPT_CLAS_CN_NM;
          item.optionItemList.forEach((item2) => {
            item2.PRESET_NM = item2.PRESET_NM_CN;
          });
        });
      } else if (this.$i18n.locale == 'tw') {
        this.optionList.forEach((item) => {
          item.OPT_CLAS_NM = item.OPT_CLAS_TW_NM;
          item.optionItemList.forEach((item2) => {
            item2.PRESET_NM = item2.PRESET_NM_TW;
          });
        });
      }
    },
  },
  components: {
    OptionInfo: optionInfo,
    SideMenu: sideMenu,
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
    optionCnt() {
      return this.optionList.length;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
    menuPersonalYn: function (val) {
      console.log('menuPersonalYn : ' + val);
      if (val) {
        // this.getOption();
      }

      try {
        // 20230407 HSSHIN Audio 재생
        if (val) {
          audioHelper.playAudio('00102', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
        } else {
          audioHelper.stopAudio();
        }
      } catch (ex) {
        console.error(ex);
      }
    },
    optionInfoYn: function (val) {
      try {
        // 20230407 HSSHIN Audio 재생
        if (val) {
          audioHelper.playAudio('00104', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
        }
      } catch (ex) {
        console.error(ex);
      }
    },
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/menu.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/menu-dark.css" scoped></style>
<style src="@/assets/css/user/pages/admin.css" scoped></style>
<style scoped>
.layer.new {
  height: 93.8vh;
  width: 88.9vw;
  padding: 3.1vh 3.1vh 8vh;
}

.menu__header .menu-title {
  font-size: 2.8em;
  margin-bottom: 1.3vh;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.menu__header .menu-image {
  width: 29.7vw;
  height: 29.7vw;
}

.menu__header .menu-info {
  width: 43.4vw;
}

.menu-price {
  font-size: 2.4em;
  margin-bottom: 0.8vh;
  line-height: 1.2em;
}

.menu-txt {
  font-size: 1.1em;
  height: 8.3vh;
}

.menu__body {
  height: auto;
  padding: 0;
  border-bottom: 2px solid var(--border-color);
}

.btn-open-txt,
.menu__body .menu__select-option .ms-head .m-txt {
  font-size: 1.4em;
}

.txt-btwbtn {
  font-size: 2em;
}

input.radio-t01 + label {
  font-size: 1.2em;
  width: 13vw;
  height: 4.6vh;
  margin-right: 16px;
}

.lst-option-wrap .lst-option {
  margin: 0px;
}

.menu__body .menu__select-option .ms-head .s-txt {
  font-size: 1.2em;
}

.menu__body .menu__select-option .row {
  height: auto;
  margin: 32px 0px;
}

.option-price dt,
.option-price dd,
.basic-price dt {
  font-size: 1.5em;
}

.layer,
.dark .layer {
  padding: 3.6vh 3.4vw 8vh;
}

.wind-detail-wrap {
  border-top: 2px solid var(--border-color);
  padding-top: 40px;
}

.wind-detail-wrap img {
  width: 100%;
}
</style>
